
const FiveStarReviewIcon = ({ className = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="136"
      height="24"
      viewBox="0 0 136 24"
      fill="none"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_56_780)">
        <path d="M17.227 16.6701L19.417 23.4121L12.004 18.0241L17.227 16.6701ZM24 9.31011H14.835L12.005 0.589111L9.165 9.31211L0 9.30011L7.422 14.6971L4.582 23.4111L12.004 18.0241L16.587 14.6971L24 9.31011Z" fill="#10B981"/>
      </g>
      <g clipPath="url(#clip1_56_780)">
        <path d="M45.227 16.6701L47.417 23.4121L40.004 18.0241L45.227 16.6701ZM52 9.31011H42.835L40.005 0.589111L37.165 9.31211L28 9.30011L35.422 14.6971L32.582 23.4111L40.004 18.0241L44.587 14.6971L52 9.31011Z" fill="#10B981"/>
      </g>
      <g clipPath="url(#clip2_56_780)">
        <path d="M73.227 16.6701L75.417 23.4121L68.004 18.0241L73.227 16.6701ZM80 9.31011H70.835L68.005 0.589111L65.165 9.31211L56 9.30011L63.422 14.6971L60.582 23.4111L68.004 18.0241L72.587 14.6971L80 9.31011Z" fill="#10B981"/>
      </g>
      <g clipPath="url(#clip3_56_780)">
        <path d="M101.227 16.6701L103.417 23.4121L96.004 18.0241L101.227 16.6701ZM108 9.31011H98.835L96.005 0.589111L93.165 9.31211L84 9.30011L91.422 14.6971L88.582 23.4111L96.004 18.0241L100.587 14.6971L108 9.31011Z" fill="#10B981"/>
      </g>
      <g clipPath="url(#clip4_56_780)">
        <path d="M129.227 16.6701L131.417 23.4121L124.004 18.0241L129.227 16.6701ZM136 9.31011H126.835L124.005 0.589111L121.165 9.31211L112 9.30011L119.422 14.6971L116.582 23.4111L124.004 18.0241L128.587 14.6971L136 9.31011Z" fill="#10B981"/>
      </g>
      <defs>
        <clipPath id="clip0_56_780">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
        <clipPath id="clip1_56_780">
          <rect width="24" height="24" fill="white" transform="translate(28)"/>
        </clipPath>
        <clipPath id="clip2_56_780">
          <rect width="24" height="24" fill="white" transform="translate(56)"/>
        </clipPath>
        <clipPath id="clip3_56_780">
          <rect width="24" height="24" fill="white" transform="translate(84)"/>
        </clipPath>
        <clipPath id="clip4_56_780">
          <rect width="24" height="24" fill="white" transform="translate(112)"/>
        </clipPath>
      </defs>
    </svg>
);

export default FiveStarReviewIcon;
